/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, April 18th 2023, 11:55:37 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { CONTACT_US_URL } from "config";
import { EnterpriseIcon } from "theme/icons";
import { COLORSCHEME } from "theme/styles";
import { EmphasisText } from "ui-widgets";
import { usePurchaseFlowStrategy } from "./usePurchaseFlowStrategy";

export const useContactUsStrategy: typeof usePurchaseFlowStrategy = () => {
  const parentStrategy = usePurchaseFlowStrategy();

  return {
    ...parentStrategy,
    getPurchaseFormTitle: (plan) => "Contact Us",
    getPurchaseFormIcon: (plan) => <EnterpriseIcon height={50} width={50} />,
    getPurchaseFormBody: (args) => (
      <Stack spacing={2}>
        <Typography variant="body1" color="gray">
          Contact us to purchase the <EmphasisText color={"rgb(105,105,105)"}>Enterprise</EmphasisText> plan.
        </Typography>
      </Stack>
    ),
    getPurchaseCTA: ({ subscriptionPlan }) => (
      <Button
        fullWidth
        size="large"
        variant="contained"
        sx={{ color: parentStrategy.getWidgets(subscriptionPlan).packageColor }}
        href={CONTACT_US_URL}
        target="_blank"
        rel="noreferrer"
      >
        <span style={{ color: COLORSCHEME.onPrimary }}>Contact Us</span>
      </Button>
    ),
  };
};
